var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentStatusApproved(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "1em",
    viewBox: "0 0 11 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.492501 3.4475H9.15352L7.53175 5.06927C7.33941 5.26157 7.33941 5.57342 7.53175 5.76576C7.62792 5.8619 7.75397 5.91 7.88001 5.91C8.00606 5.91 8.13211 5.8619 8.22824 5.76573L10.6907 3.30323C10.8831 3.11092 10.8831 2.79907 10.6907 2.60673L8.22824 0.144229C8.03594 -0.0480763 7.72409 -0.0480763 7.53175 0.144229C7.33941 0.336534 7.33941 0.648386 7.53175 0.840723L9.15352 2.4625H0.492501C0.220509 2.4625 0 2.683 0 2.955C0 3.22699 0.220509 3.4475 0.492501 3.4475Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentStatusApproved);
export default __webpack_public_path__ + "static/media/payment-status-approved.2ed05441877a219a00bf26bc5bc7f863.svg";
export { ForwardRef as ReactComponent };